// SessionTabBar — P3.2. Abas de SESSÃO persistentes, estilo navegador, que aparecem
// tanto na aba Code quanto na Chat. Clicar numa aba ATIVA a sessão E troca a surface
// (code/chat) automaticamente — o usuário alterna entre conversas sem precisar clicar
// em "Code"/"Chat" no header. Estilo Cursor: superfície neutra, radii 6px, sem azul/glow.
import { MessageSquare, SquareTerminal, X } from 'lucide-react';
import { useAgentStore } from '../store/useAgentStore.js';

export default function SessionTabBar() {
  const openTabs = useAgentStore((s) => s.code.openTabs);
  const activeSessionId = useAgentStore((s) => s.code.activeSessionId);
  const activeWorkspace = useAgentStore((s) => s.activeWorkspace);
  const setActiveSession = useAgentStore((s) => s.setActiveSession);
  const setActiveWorkspace = useAgentStore((s) => s.setActiveWorkspace);
  const closeSessionTab = useAgentStore((s) => s.closeSessionTab);

  // As abas só fazem sentido nas surfaces de sessão (Code/Chat).
  if (!Array.isArray(openTabs) || openTabs.length === 0) return null;
  if (activeWorkspace !== 'code' && activeWorkspace !== 'chat') return null;

  const selectTab = (tab) => {
    // Troca a surface pro kind da aba ANTES de ativar, pra o SessionWorkspace certo montar.
    setActiveWorkspace(tab.kind === 'chat' ? 'chat' : 'code');
    setActiveSession(tab.id);
  };

  return (
    <div
      className="flex shrink-0 items-center gap-1 overflow-x-auto border-b border-apolo-border bg-apolo-surface1 px-2 py-1"
      role="tablist"
      aria-label="Sessões abertas"
    >
      {openTabs.map((tab) => {
        const isActive = tab.id === activeSessionId;
        const Icon = tab.kind === 'chat' ? MessageSquare : SquareTerminal;
        return (
          <div
            key={tab.id}
            role="tab"
            aria-selected={isActive}
            tabIndex={0}
            onClick={() => selectTab(tab)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectTab(tab); } }}
            title={tab.title}
            className={`group flex max-w-[180px] shrink-0 cursor-pointer items-center gap-1.5 rounded-md px-2 py-1 text-xs transition ${
              isActive
                ? 'bg-apolo-surface3 text-apolo-textPrimary'
                : 'text-apolo-textSecondary hover:bg-apolo-surface2'
            }`}
          >
            <Icon size={13} aria-hidden="true" className="shrink-0 text-apolo-textTertiary" />
            <span className="flex-1 truncate">{tab.title || 'Sessão'}</span>
            <button
              type="button"
              aria-label={`Fechar ${tab.title || 'sessão'}`}
              onClick={(e) => { e.stopPropagation(); closeSessionTab(tab.id); }}
              className="shrink-0 rounded p-0.5 text-apolo-textTertiary opacity-0 transition hover:text-apolo-error group-hover:opacity-100 focus:opacity-100"
            >
              <X size={11} aria-hidden="true" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
